export type ProviderCode = 'tabby' | 'tamara' | 'cashew';

export type ProviderConfig = {
  code: ProviderCode;
  name: string;
  tenors: number[];                // e.g., [3,6,12]
  aprRange?: [number, number];     // optional APR band if disclosed
  enabled: boolean;
  currency?: string;               // default 'AED'
  logoUrl?: string;                // optional UI use
  supportsPrecheck?: boolean;      // if provider offers soft eligibility check
};

export type CreateCheckoutPayload = {
  amountAED: number;
  customer: { name: string; email: string; phone?: string };
  metadata?: Record<string, any>;  // include listingId, leadId, utm, etc.
  returnUrl: string;               // where the provider should redirect back
};

export type ProviderAdapter = {
  getConfig: () => Promise<ProviderConfig>;
  createCheckoutLink: (payload: CreateCheckoutPayload) => Promise<{ url: string }>;
  verifyWebhook?: (req: Request) => Promise<{ ok: boolean; event?: string; data?: any }>;
};

export async function getAdapter(code: ProviderCode): Promise<ProviderAdapter> {
  switch (code) {
    case 'tabby':  return (await import('./tabby')).default;
    case 'tamara': return (await import('./tamara')).default;
    case 'cashew': return (await import('./cashew')).default;
    default: throw new Error(`Unknown provider: ${code}`);
  }
}

/** Helper for monthly price examples (UI only) */
export function calcMonthly(amountAED: number, tenor: number) {
  return Math.ceil(amountAED / Math.max(tenor, 1));
}